import API from '../api'
import { push, go } from 'react-router-redux/lib/actions';
import { notify } from './message';
import { handleError } from './error';

export const AUTH_LOGIN_PROGRESS = 'AUTH_LOGIN_PROGRESS';
export const AUTH_LOGIN_SUCCESS = 'AUTH_LOGIN_SUCCESS';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const AUTH_RESTORE = 'AUTH_RESTORE';
export const AUTH_UPDATE_PASSWORD_TOKEN = 'AUTH_UPDATE_PASSWORD_TOKEN';

export const UPDATE_PASSWORD_TOKEN_NEW = 'new';
export const UPDATE_PASSWORD_TOKEN_EXPIRED = 'expired';
export const UPDATE_PASSWORD_TOKEN_USED = 'used';
export const UPDATE_PASSWORD_TOKEN_WRONG = 'wrong';
export const AUTH_CONFIRM_TOKEN_CHECKED = 'AUTH_CONFIRM_TOKEN_CHECKED';

export const UPDATE_PASSWORD_TOKEN_STATUSES = [
  UPDATE_PASSWORD_TOKEN_NEW,
  UPDATE_PASSWORD_TOKEN_EXPIRED,
  UPDATE_PASSWORD_TOKEN_USED,
  UPDATE_PASSWORD_TOKEN_WRONG
];

/**
 * Login action
 * @param userName
 * @param password
 * @returns {{type: string, username: *, password: *}}
 * @constructor
 */
export function login(userName, password, nextPathname) {
  let redirectPath = nextPathname ? nextPathname : '/fanbox';
  return (dispatch) => {
    // set progress variable, test
    dispatch(progressLogin());

    return API.Auth.login(userName, password)
      .then((response) => dispatch(successLogin(response, redirectPath)))
      .catch((error) => dispatch(handleError(error)));
  };
}

export function logout() {
  return (dispatch) => {
    return API.Auth.logout()
      .then(() => {
        dispatch(go('/login'));
        dispatch(logoutInternal());
      });
  }
}

export function restoreUser(token) {
  
  if(!!token) {
    return (dispatch) => {
      return API.Auth.restore()
        .then((user) => dispatch({
            type: AUTH_RESTORE,
            user
          }))
        .catch(() => dispatch(logoutInternal()));
    }
  } else {
    return (dispatch) => {
      dispatch(logoutInternal());
      return Promise.resolve(null);
    }
  }
}

export function forgotPassword(email) {
  return (dispatch) => API.Auth.forgotPassword(email)
    .then(({message}) => dispatch(notify(message)))
    .then(() => dispatch(go('/login')))
    .catch((data) => Promise.reject(data.errors));
}

export function checkUpdatePasswordToken(updateToken) {
  return dispatch => API.Auth.checkUpdatePasswordToken(updateToken)
    .then(response => dispatch(authUpdatePasswordToken(updateToken, response.status)))
    .catch(() => dispatch(authUpdatePasswordToken(updateToken, UPDATE_PASSWORD_TOKEN_WRONG)))
}

export function updatePassword(password, updateToken) {
  return dispatch => API.Auth.updatePassword(password, updateToken)
    .then((response) => dispatch(successLogin(response)))
    .then(() => dispatch(notify('Password has updated successful')))
    .catch((error) => dispatch(handleError(error)));
}

function logoutInternal() {
  return {
    type: AUTH_LOGOUT
  }
}

function progressLogin() {
  return {
    type: AUTH_LOGIN_PROGRESS
  };
}

/**
 * Change state
 *
 * @param user
 * @param token
 * @returns {{type: string, user: *, token: *}}
 */
function successLogin({token}, redirectPath) {
  return dispatch =>
    Promise.resolve(dispatch({
        type: AUTH_LOGIN_SUCCESS,
        token
      }))
      .then(() => dispatch(restoreUser(token)))
      .then(() => dispatch(push(redirectPath)));
}

/**
 *
 * @param {string} token
 * @param {status} status
 * @returns {{type: string, token: *, status: *}}
 */
function authUpdatePasswordToken(token, status) {
  return {
    type: AUTH_UPDATE_PASSWORD_TOKEN,
    token,
    status
  }
}

export function authUpdatePasswordToken(confirmTokenValid) {
  return {
    type: AUTH_CONFIRM_TOKEN_CHECKED,
    confirmTokenValid
  }
}



// WEBPACK FOOTER //
// ./src/actions/auth.js